

// import { getToken } from "./api";

// const BASE_URL = "https://livestream.techzeus.co/api";

// export async function getJobs(categoryId = null, onProgress = null) {
//   const token = await getToken();

//   const pageSize = 200;
//   let page = 1;
//   let allJobs = [];

//   while (true) {
//     let url = `${BASE_URL}/business/jobs?page=${page}&pageSize=${pageSize}&sort=id:desc&tab=all&status=completed`;

//     if (categoryId) {
//       url += `&categoryId=${categoryId}`;
//     }

//     console.log(`Fetching page ${page}:`, url);

//     const response = await fetch(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Unable to fetch jobs (page ${page})`);
//     }

//     const jsonResponse = await response.json();
//     const rawJobs = jsonResponse.data || [];

//     // Stop if this page has no jobs
//     if (rawJobs.length === 0) {
//       break;
//     }

//     // Filter jobs having snapper.jobId and preserve postedOn timestamp
//     const mappedJobs = rawJobs
//       .filter((job) => job.snapper?.jobId)
//       .map((job) => ({
//         id: job.id,
//         messageJobId: job.snapper.jobId,
//         title: job.title || job.name || `Job #${job.snapper.jobId}`,
//         snapJobId: job.snapJobId || job.snapper.jobId,
//         status: job.status,
//         postedOn: job.postedOn,
//         completedAt: job.completedAt,
//       }));

//     allJobs.push(...mappedJobs);

//     // Stream accumulated jobs to the UI immediately
//     if (onProgress) {
//       onProgress([...allJobs], page, rawJobs.length < pageSize);
//     }

//     console.log(
//       `Fetched page ${page}: ${mappedJobs.length} jobs (Total: ${allJobs.length})`
//     );

//     // Stop fetching if the last page returned fewer items than max page size
//     if (rawJobs.length < pageSize) {
//       break;
//     }

//     page++;
//   }

//   console.log(`Total jobs fetched: ${allJobs.length}`);

//   return {
//     data: allJobs,
//   };
// }

import { getToken } from "./api";

const BASE_URL = "https://livestream.techzeus.co/api";

export async function getJobs(
  categoryId = null,
  onProgress = null,
  status = "completed"
) {
  const token = await getToken();

  const pageSize = 200;
  let page = 1;
  let allJobs = [];

  while (true) {
    let url = `${BASE_URL}/business/jobs?page=${page}&pageSize=${pageSize}&sort=id:desc&tab=all&status=${status}`;

    if (categoryId) {
      url += `&categoryId=${categoryId}`;
    }

    console.log(`Fetching page ${page}:`, url);

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Unable to fetch jobs (page ${page})`);
    }

    const jsonResponse = await response.json();
    const rawJobs = jsonResponse.data || [];

    // Stop if this page has no jobs
    if (rawJobs.length === 0) {
      break;
    }

    // Filter jobs having snapper.jobId and preserve postedOn timestamp
    const mappedJobs = rawJobs.map((job) => ({
    id: job.id,
    messageJobId: job.snapper?.jobId || null,
    title: job.title || job.name || `Job #${job.id}`,
    snapJobId: job.snapJobId || job.snapper?.jobId || null,
    status: job.status,
    postedOn: job.postedOn,
    completedAt: job.completedAt,
  }));

    allJobs.push(...mappedJobs);

    // Stream accumulated jobs to the UI immediately
    if (onProgress) {
      onProgress([...allJobs], page, rawJobs.length < pageSize);
    }

    console.log(
      `Fetched page ${page}: ${mappedJobs.length} jobs (Total: ${allJobs.length})`
    );

    // Stop fetching if the last page returned fewer items than max page size
    if (rawJobs.length < pageSize) {
      break;
    }

    page++;
  }

  console.log(`Total jobs fetched: ${allJobs.length}`);

  return {
    data: allJobs,
  };
}